import functions from "./functions";
import axios from "axios";

var fin129 = {
  async createFin129(fin129) {
    var url = `${process.env.VUE_APP_STRAPI_URL}/api/fin129/createFin129`;
    var body = JSON.stringify(fin129);
    try {
      let ans = await axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${process.env.VUE_APP_STRAPI_TOKEN}`,
          "Content-Type": "application/json",
        },
      });
      return ans;
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        const { status, statusText, data } = error.response;
        if (data?.itemMessages)
          throw new Error(
            data?.itemMessages.map((el) => JSON.stringify(el))?.join(",")
          );
        if (data?.errors)
          throw new Error(data?.errors.map((el) => el.message)?.join(",")); // Rethrow or handle the error
        if (data?.error) throw new Error(data?.error.message); // Rethrow or handle the error
        if (data?.detail) {
          if (Array.isArray(data?.detail))
            throw new Error(
              data?.detail?.map((el) => JSON.stringify(el))?.join("\n")
            ); // Rethrow or handle the error
          throw new Error(data?.detail); // Rethrow or handle the error
        }
      } else if (error.request) {
        throw new Error("No response from the server.");
      } else {
        throw new Error("An error occurred while setting up the request.");
      }
    }
  },

  async getWithPagination(page, pageSize, sort, sortDesc, filters) {
    var query = `query fin129s($filters:Fin129FiltersInput!){
      fin129S( sort:"${sort}${
      sortDesc ? ":desc" : ""
    }" filters:$filters ,pagination:{page:${page},pageSize:${pageSize}}){
        meta{
          pagination{
            total
            pageSize
            page
          }
        }
        data{
          id
          attributes{
            createdAt
            tnsCod
            tnsMnyValor
            owner{
              data{
                id
                attributes{
                  username
                }
              }
            }
            fin129items{
              data{
                id
                attributes{
                  description
                  tsdMnyValor
                  ctpCod
                }
                
              }
            }
          }
        }
      }
    }
    `;

    var graphql = JSON.stringify({
      query,
      variables: {
        filters,
      },
    });
    var url = `${process.env.VUE_APP_STRAPI_URL}/graphql`;
    var res = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${process.env.VUE_APP_STRAPI_TOKEN}`,
        "Content-Type": "application/json",
      },
      body: graphql,
    })
      .then((res) => {
        if (window.debug) console.log(res);
        return res.json();
      })
      .then((json) => {
        if (window.debug) console.log(json);
        return json;
      });

    const end = Date.now();
    if (window.debug)
      console.log(
        `Execution getWithPagination vwFechProcDespesas time: ${
          (end - start) / 1000
        } s`
      );

    const pagination = res?.data?.fin129S?.meta?.pagination;
    const values = functions.sanitize(res.data.fin129S.data);
    return { values, pagination };
  },
};

export default fin129;
